import { createSlice } from "@reduxjs/toolkit";

const alertsFilterSlice = createSlice({
  name: 'alertsFilter',
  initialState: { hasAlerts: false },
  reducers: {
    toggleAlertsFilter: (state, action) => {
      state.hasAlerts = action.payload;
    },
  },
});

export const { toggleAlertsFilter } = alertsFilterSlice.actions;
export default alertsFilterSlice.reducer;
